import { LocalStorageKeys } from '@authentication/constants';
import LoginResponse from '@authentication/models/login.response.dto';

export const setItem = (key: string, value: unknown): void => {
  try {
    window.localStorage.setItem(key, removeQuotes(JSON.stringify(value)));
  } catch (e) {
    console.error(e);
  }
};

export const setItemWithQuotes = (key: string, value: unknown): void => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.error(e);
  }
};

export const getItem = (key: string): string | null => {
  return window.localStorage.getItem(key);
};
export const removeQuotes = (str: string): string => {
  return str.replace(/['"]+/g, '');
};

export const saveUserCache = (loginResponse: LoginResponse) => {
  window.localStorage.clear();
  setItem(LocalStorageKeys.USER_ID, loginResponse?.user.id);
  setItem(LocalStorageKeys.ACCESS_TOKEN, loginResponse?.accessToken);
  setItem(LocalStorageKeys.REFRESH_TOKEN, loginResponse?.refreshToken);
  if (loginResponse?.enterprise)
    setItemWithQuotes(
      LocalStorageKeys.ROLES_ENTREPRISE,
      loginResponse?.enterprise,
    );
  if (loginResponse?.establishments)
    setItemWithQuotes(
      LocalStorageKeys.ROLES_ESTABLISHEMENTS,
      loginResponse?.establishments,
    );
};

export const destroyUserCache = () => {
  window.localStorage.clear();
};
